import { Enemy } from './Enemy.js'
import { PLAYER_DAMAGE } from '../game/CombatBalance.js'

export class CinderImp extends Enemy {
  constructor(game, x, y, id) {
    super(game, x, y, id, 'cinderImp')

    this.maxHealth = 40
    this.health = 40
    this.damage = PLAYER_DAMAGE.LIGHT
    this.moveSpeed = 3.5
    this.attackRange = 9
    this.attackCooldown = 3.5
    this.detectionRange = 16
    this.projectiles = []
  }

  update(delta) {
    super.update(delta)

    for (let i = this.projectiles.length - 1; i >= 0; i--) {
      const projectile = this.projectiles[i]
      projectile.x += projectile.dirX * projectile.speed * delta
      projectile.y += projectile.dirY * projectile.speed * delta
      projectile.lifetime -= delta

      const dx = projectile.x - this.game.player.x
      const dy = projectile.y - this.game.player.y
      if (Math.sqrt(dx * dx + dy * dy) < 0.55) {
        this.game.player.takeDamage(this.damage * this.damageMultiplier)
        this.projectiles.splice(i, 1)
      } else if (projectile.lifetime <= 0 || this.game.world.isSolid(projectile.x, projectile.y)) {
        this.projectiles.splice(i, 1)
      }
    }
  }

  attack() {
    const dx = this.game.player.x - this.x
    const dy = this.game.player.y - this.y
    const distance = Math.sqrt(dx * dx + dy * dy)
    if (distance === 0) return

    this.projectiles.push({
      x: this.x,
      y: this.y,
      dirX: dx / distance,
      dirY: dy / distance,
      speed: 6,
      lifetime: 3
    })
  }

  render(renderer) {
    super.render(renderer)
    for (const projectile of this.projectiles) {
      renderer.fillCircle(projectile.x, projectile.y, 0.22, '#ff5b1a')
      renderer.fillCircle(projectile.x, projectile.y, 0.1, '#ffe36b')
    }
  }

  die() {
    this.projectiles = []
    super.die()
  }
}
